import { render, staticRenderFns } from "./PharmaceuticsComponent.vue?vue&type=template&id=3b18b9fb&scoped=true"
import script from "./PharmaceuticsComponent.vue?vue&type=script&lang=js"
export * from "./PharmaceuticsComponent.vue?vue&type=script&lang=js"
import style0 from "./PharmaceuticsComponent.vue?vue&type=style&index=0&id=3b18b9fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b18b9fb",
  null
  
)

export default component.exports